import React, { useRef, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    Text,
    Link,

    /* Hooks */
    useMultiStyleConfig
} from '@chakra-ui/react'

/* Utils */
import { generateStyles } from '../../utils/utils'
import { useIntl } from 'react-intl'

const SeoFooterStyleBlock = ({
    seoContent, // This is coming from BM - category level
    categoryName, // This is coming from BM - category level
    seoFooterStyleBlockContainerStyle,
    SeeLessText,
    SeeMoreText,
    SeeMoreLessTextStyle,
    SeoFooterStyleBlockTitleStyle,
    SeoFooterStyleBlockTextStyle,
}) => {
    const intl = useIntl()
    const styles = useMultiStyleConfig('SeoFooterStyleBlock')
    const NO_OF_LINES = 3
    const contentRef = useRef(null)
    const [isExpanded, setIsExpanded] = useState(false)
    const [shouldShowReadMore, setShouldShowReadMore] = useState(false)
    const [fullHeight, setFullHeight] = useState(null) // null = auto for SSR
    const [collapsedHeight, setCollapsedHeight] = useState(null) // null = auto for SSR

    useEffect(() => {
        if (contentRef.current) {
            const offset = 2 // To not show cut content
            const lineHeight = parseInt(
                window.getComputedStyle(contentRef.current).lineHeight,
                10
            )
            const threeLineHeight = (lineHeight * NO_OF_LINES) + offset
            const scrollHeight = contentRef.current.scrollHeight + offset

            setFullHeight(scrollHeight)
            setCollapsedHeight(threeLineHeight)
            setShouldShowReadMore(scrollHeight > threeLineHeight)
        }
    }, [seoContent])

    const handleToggleReadMore = (e) => {
        if (e) e.preventDefault()
        setIsExpanded(!isExpanded)
    }

    if (!seoContent) {
        return
    }

    return (
        <Box {...styles.container}
            {...seoFooterStyleBlockContainerStyle}
            data-block-type="SeoFooterStyleBlock">
            <Text {...generateStyles(SeoFooterStyleBlockTitleStyle, { ...styles.title })} >
                {categoryName}
            </Text>

            <Box
                overflow="hidden"
                height={
                    fullHeight !== null && collapsedHeight !== null
                        ? isExpanded ? `${fullHeight}px` : `${collapsedHeight}px`
                        : 'auto' // Use 'auto' during SSR before heights are calculated
                }
                transition="height 0.3s ease-in-out"
            >
                <Box
                    ref={contentRef}
                    {...generateStyles(SeoFooterStyleBlockTextStyle, { ...styles.content })}
                    dangerouslySetInnerHTML={{ __html: seoContent }}
                />
            </Box>

            {shouldShowReadMore && (
                <Link
                    href={'#'}
                    onClick={handleToggleReadMore}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            if (e) e.preventDefault()
                            handleToggleReadMore()?.(e)
                        }
                    }}
                    {...generateStyles(SeeMoreLessTextStyle, { ...styles?.showHideCta })}
                >
                    {isExpanded ? SeeLessText || intl.formatMessage({ id: 'plp.seo.read_less', defaultMessage: 'Read Less' }) : SeeMoreText || intl.formatMessage({ id: 'plp.seo.read_more', defaultMessage: 'Read More' })}
                </Link>
            )}
        </Box>
    )
}

SeoFooterStyleBlock.propTypes = {
    seoContent: PropTypes.string,
    categoryName: PropTypes.string,
    seoFooterStyleBlockContainerStyle: PropTypes.object,
    SeeLessText: PropTypes.string,
    SeeMoreText: PropTypes.string,
    SeeMoreLessTextStyle: PropTypes.object,
    SeoFooterStyleBlockTitleStyle: PropTypes.object,
    SeoFooterStyleBlockTextStyle: PropTypes.object,
}

export default SeoFooterStyleBlock
